import { useQuery, type UseQueryResult } from 'react-query'

import type { TrendDetectionService } from 'features/trend-detection/service/service'
import type { BenchmarkingAgentDetail } from 'features/trend-detection/types'

export interface UseEditBenchmarkingAgentQueryParams {
  service: TrendDetectionService
  projectId: string | null
  agentId: string | null
  enabled: boolean
}

/** The edit-mode create form's benchmarking-agent fetch. Split out of the
 * Container so a TanStack query hook doesn't live inline there. */
export function useEditBenchmarkingAgentQuery({
  service,
  projectId,
  agentId,
  enabled,
}: UseEditBenchmarkingAgentQueryParams): UseQueryResult<BenchmarkingAgentDetail> {
  return useQuery({
    queryKey: ['benchmarking-agent', projectId, agentId],
    queryFn: async () => {
      if (!projectId || !agentId) throw new Error('missing')
      return service.fetchBenchmarkingAgent(projectId, agentId)
    },
    enabled,
  })
}
